
    const data = {"name":"src/core/icons/content-copy","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 21H8V7h11m0-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-3-4H4a2 2 0 0 0-2 2v14h2V3h12V1Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            